import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "./SimplePresentationRunner";
import {FlightMode} from "../FlightMode";
import {WinConfigBased, WinConfigUtilBased} from "../misc/WinConfigUtil";
import {FlightModeSound} from "../misc/FlightModeSound";

export class WinCountUp implements SimplePresentation {

    name:string = "NormalWin";

    shouldRun():boolean {
        return FlightMode.model.avalancheWin > 0 &&
               FlightMode.model.avalanchesAreDone() &&
               !FlightMode.model.brokeTheBank &&
               !FlightMode.isWinBelowStake() ;

    }

    start(controller:SimplePresentationRunnerController):void {
        const featureName = FlightMode.model.buyFeatureName;
        const threshold =
            WinConfigUtilBased.bigWinThresholds[featureName] != undefined
                ? WinConfigUtilBased.bigWinThresholds[featureName]
                : 15;

        const isBigWin = FlightMode.model.winRatio >= threshold;
        const tl = gsap.timeline();

        if (isBigWin) {
            const bigLevels = WinConfigUtilBased.bigLevels;
            const winRatio = FlightMode.model.winRatio;
            const configs = bigLevels.filter((winLevel) => winLevel.fromRatio < winRatio);

            tl.add(() => {
                FlightMode.soundPlayer.fadeOutMusic()
                FlightMode.soundPlayer.playSound("preBigWin");
            }, '>0.67');

            configs.forEach((config, index) => {
                tl.add(() => {
                    controller.setSkipCallback(() => {
                        tl.seek(`bigWinLevel${index}`, false);
                        FlightMode.soundPlayer.stopSound(`bigWinLevel${index + 1}`);
                    });
                });

                const isFirst = index == 0;
                const isLast  = index == (configs.length - 1);
                const to      = FlightMode.model.playedBetValue * Math.min(config.toRatio,
                                                                FlightMode.model.winRatio);
                const from    = FlightMode.model.playedBetValue * config.fromRatio;

                tl.add(() => {
                    FlightMode.soundPlayer.playSound(`bigWinLevel${index + 1}`);
                    FlightMode.soundPlayer.playSound(FlightModeSound.BIG_WIN_CHANGE);
                });
                if (isFirst)
                    tl.add(FlightMode.winView.bigWinStart(to, from, index + 1), '<');
                else
                    tl.add(FlightMode.winView.bigWinMiddle(to, from, index + 1));
                if (isLast) {
                    tl.add(FlightMode.winView.bigWinEnd(index + 1));
                    tl.add(() => {
                        FlightMode.soundPlayer.playSound(FlightModeSound.BIG_WIN_END);
                        controller.setSkipCallback();
                    }, '<');
                }

                tl.addLabel(`bigWinLevel${index}`, isLast ? '<' : '>');
            });

            tl.add(() => FlightMode.soundPlayer.fadeInMusic());
            tl.add(() => {}, '>0.2');

        } else {
            const configs = WinConfigUtilBased.normalLevels;
            const winLevelConfig =
                configs.filter((config) => config.fromRatio < FlightMode.model.winRatio).pop();
            const duration = winLevelConfig!.duration;
            const sound = winLevelConfig!.sound;

            tl.add(() => {
                controller.setSkipCallback(() => {
                    tl.seek("SKIP_LOL", false);
                    FlightMode.soundPlayer.stopSound(sound.start);
                    FlightMode.soundPlayer.stopSound(sound.sound);
                    controller.setSkipCallback();
                });
            });

            tl.add(() => FlightMode.soundPlayer.playSound(sound.start), '>0.35');
            tl.add(() => FlightMode.soundPlayer.playSound(sound.sound));
            tl.add(FlightMode.winView.countUpWin(FlightMode.model.avalancheWin, 0, duration), '<');
            tl.add(() => {
                controller.setSkipCallback();
            }, '>-0.6')
            tl.addLabel("SKIP_LOL", '<')
            tl.add(() => FlightMode.soundPlayer.playSound(sound.end), '<');
        }

        tl.add(() => {
            controller.setSkipCallback();
            controller.finish()
        });
    }
}